import i18n from "../../../i18n/i18n";

const apiUrl = (process.env.REACT_APP_BACKEND as string) + '/api';

interface FinanceCapacityData {
  name: string;
  date: string;
  time: string;
  place: string;
  lat: number;
  lon: number;
  email: string;
  link: string;
  lang?: string;
}

enum ExperimentType {
  A = 'indi_banner_typea',
  B = 'indi_banner_typeb',
  C = 'indi_banner_typec',
  D = 'indi_banner_typed',
  E = 'indi_banner_typee',
}

const getExperimentType = (): ExperimentType => {
  // пока не удаляем, возможно экперементы с баннерами еще будут
  // const values = Object.values(ExperimentType);

  // return values[
  //   Math.floor(Math.random() * values.length)
  // ];
  return ExperimentType.E;
};

export async function getNatalTelegramLink(
  data: FinanceCapacityData,
  kind: 'telegram' | 'web'
) {
  let url = `${apiUrl}/natal-calc-telegram`;
  const payload = {...data, lang: i18n.language}

  const result = await fetch(url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
    credentials: 'include',
  }).then((response) => response.json());
 
  const tgLink = result?.data?.telegramLink
  
  if (!tgLink){
    alert('Ошибка при обращении к серверу');
    console.log('Ошибка ', result);
    return 0;
  } 

  if (kind === 'telegram') return tgLink 
  const id = tgLink.match(/id_fy=(\d+)/)?.[1]

  return id ? `https://indi.chronos.mg/natal/${id}` : 0;
}

export async function getNatalLink(
  data: FinanceCapacityData,
) {
  let url = `${apiUrl}/new-natal-calc`;
  const payload = {...data, lang: i18n.language, type: getExperimentType()}

  const result = await fetch(url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
    credentials: 'include',
  }).then((response) => response.json());
 
  const link = result?.data?.link
  
  if (!link){
    alert('Ошибка при обращении к серверу');
    console.log('Ошибка ', result);
    return 0;
  } 

  return link;
}

export async function getNewNatalLink(
  data: FinanceCapacityData,
) {
  let url = `${apiUrl}/marathon-natal-calc`;
  const payload = {...data, lang: i18n.language}

  const result = await fetch(url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
    credentials: 'include',
  }).then((response) => response.json());
 
  const link = result?.data?.link
  
  if (!link){
    alert('Ошибка при обращении к серверу');
    console.log('Ошибка ', result);
    return 0;
  } 

  return link;
}

export const getPartnerToken = (partner: string) => {
  if(partner === 'lab_landing') return partner;
  return 'jtmIb4uN0zMZcpaz';
}
